<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />

<div class="container er-page er-chatpage">
<div class="er-page-head">
    <p class="er-eyebrow">Support</p>
    <h1 class="er-page-title">Complaint chat</h1>
</div>
<div class="row clearfix">
    <div class="col-lg-12">
        <div class="card chat-app">
           
            <div class="chat">
                <div class="chat-header clearfix">
                    <div class="row">
                        <div class="col-lg-6">
                            <a href="javascript:void(0);" data-toggle="modal" data-target="#view_info">
                                <i class="fa fa-comments-o chat-icon" title="Open Chat" aria-hidden="true"></i>
                            </a>
                            <div class="chat-about">
                                <h6 class="m-b-0">Chats</h6>
                            </div>
                        </div>
                      
                    </div>
                </div>
                <div class="chat-history" *ngFor="let chat of ComplaintList[0].chats">
                    <ul class="m-b-0">
                        <li class="clearfix" *ngIf="chat.messageBy=='USER'" >
                            <div class="message-data text-right">
                                <span class="description">{{currentUserDetails}}</span>
                                <i class="fa fa-user-circle my-user" aria-hidden="true"></i><br>
                            <span class="message-data-time">{{chat.createdDate | date:'dd MMM yy, h:mm a'}}</span>
                            </div>
                            
                            <div class="message other-message float-right"> 
                            <a title="View File" *ngIf="chat.complainattachment!=null" href="https://yourmudrauatreceipt.yourmudra.com/complaint/{{chat.complainattachment}}" target="_blank" download>

                                <img  class="image" *ngIf="chat.complainattachment!=null && !(chat.complainattachment.includes('.mp4'))" src="https://yourmudrauatreceipt.yourmudra.com/complaint/{{chat.complainattachment}}">
                            <div *ngIf="chat.complainattachment && chat.complainattachment.includes('.mp4')" src="https://yourmudrauatreceipt.yourmudra.com/complaint/{{chat.complainattachment}}">
                                <video class="video-style" *ngIf="chat.complainattachment!=null && chat.complainattachment.includes('.mp4')" src="https://yourmudrauatreceipt.yourmudra.com/complaint/{{chat.complainattachment}}" width="200" height="150" controls>
                                </video>
                            </div><br>
                            </a>
                                <span class="txt-msg" >{{chat.description}}</span> <br>
                            </div>

                        </li>
                        <li class="clearfix" *ngIf="chat.messageBy=='ADMIN'">
                            <div class="message-data" *ngIf="chat.messageBy">
                                <span class="description">{{chat.messageBy}}</span>
                                <i class="fa fa-user-circle admin-user" aria-hidden="true"></i><br>
                                <span style="font-weight: 600;">{{chat.resolvedByUserName}} ~ {{chat.resolvedByUserEmail}}</span><br>

                                <span class="message-data-time">{{chat.createdDate | date:'dd MMM yy, h:mm a'}}</span>

                            </div>
                            <div class="message my-message" *ngIf="chat.resolvedByUserName">{{chat.description}}</div>                                    
                        </li>  
                    </ul>
                </div>
                <div class="chat-message clearfix" *ngIf="isChat">
                  <form [formGroup]="ComplaintChatForm">

                    <div class="input-group mb-0">
                        <div class="row" style="width: 100%;margin-left: 5%;">
                        <div class="col-md-9" style="border: 1px solid lightgray;border-radius: 5px;">
                           <input type="text" class="text-input" (input)="onSearchChange($event.target.value)" formControlName="description" placeholder="Enter text here...">                                     
                        </div>
                        <div class="col-md-1" style="text-align: center;margin-left: -6%;">
                         
                            <label style="display: none;">
                                <input id="upload_file" type="file" #file accept="image/x-png,image/jpeg,image/jpg/video/mp4,video/x-m4v,video/*" (change)="personalPhoto($event)">
                              </label>
                            <span>
                            <i class="fa fa-paperclip" aria-hidden="true">
                                <input class="attachment-input" readonly="true" type="text" id="file" (focus)="trigger()"></i></span>
                           

                          </div>
                       
                        <div class="col-md-1" style="margin-left: -25px;">
                            <span *ngIf="emptyText"  class="input-group-text"><i class="fa fa-send"></i></span>
                            <span  *ngIf="!emptyText" (click)="sendReply()" class="input-group-text2"><i class="fa fa-send"></i></span>

                          </div>
                          <div class="col-md-1" style="text-align: center;">
                            <i *ngIf="UserImagefilerealimageflag" class="fa fa-close" (click)="removeFile()"></i>
                           <img  *ngIf="isImage && UserImagefilerealimageflag" mat-card-image src="{{userImagefilerealimage}}" alt="" style="height:100px ; width:170px ;" >
                           <video *ngIf="isVideo && UserImagefilerealimageflag" mat-card-image src="{{userImagefilerealimage}}" width="250" height="150" style="margin-left: 12%;
                           margin-top: -30px;" controls></video>
                        </div>
                        </div>
                      
                    </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<button type="button" class="er-btn er-btn--ghost" (click)="OpenList()">Back to complaints</button>

</div>